export default "__VITE_ASSET__BSjzSwze__"